import React from 'react';
import PageInfo from '../components/PageInfo';
import DataIntegritySingle from '../components/DataIntegrity/Single';

export default function DataIntegrity(props) {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:pt-16">
            <PageInfo title={props.title} subtitle={props.subtitle} />
            <DataIntegritySingle  />
        </div>
    );
}